module.exports = __webpack_public_path__ + "static/media/01.45a2f60e.mp3";